<template>
    <page-header-wrapper>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <!-- <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="参数名称">
                  <a-input v-model="queryParam.configName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="参数键名">
                  <a-input v-model="queryParam.configKey" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
                <a-col :md="8" :sm="24">
                  <a-form-item label="系统内置">
                    <a-select placeholder="请选择" v-model="queryParam.configSystem" style="width: 100%" allow-clear>
                      <a-select-option v-for="(d, index) in dict.type['sys_yes_no']" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="创建时间">
                    <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" allow-clear/>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :md="!advanced && 8 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div> -->
        <!-- 操作 -->
        <div class="table-operations">
  <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:config:add']">-->
  <!--          <a-icon type="plus" />新增-->
  <!--        </a-button>-->
  <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['system:config:edit']">-->
  <!--          <a-icon type="edit" />修改-->
  <!--        </a-button>-->
  <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:config:remove']">-->
  <!--          <a-icon type="delete" />删除-->
  <!--        </a-button>-->
  <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['system:config:export']">-->
  <!--          <a-icon type="download" />导出-->
  <!--        </a-button>-->
  <!--        <a-button type="dashed" :loading="refreshing" @click="handleRefreshCache" v-hasPermi="['system:config:remove']">-->
  <!--          <a-icon type="redo" />刷新缓存-->
  <!--        </a-button>-->
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 增加修改 -->
        <create-form
          ref="createForm"
          :typeOptions="dict.type['sys_yes_no']"
          @ok="getList"
        />
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered">
          <span slot="configSystem" slot-scope="text, record">
            <dict-tag :options="dict.type['sys_yes_no']" :value="record.configSystem" />
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:config:edit']">
              <a-icon type="edit" />修改
            </a>
  <!--          <a-divider type="vertical" v-hasPermi="['system:config:remove']" />-->
  <!--          <a @click="handleDelete(record)" v-hasPermi="['system:config:remove']">-->
  <!--            <a-icon type="delete" />删除-->
  <!--          </a>-->
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
          :rowKey="(record, index) => index + 1"
        />
      </a-card>
    </page-header-wrapper>
  </template>
  
  <script>
  
  import { pageConfig, delConfig, refreshCache } from '@/api/system/config'
  import CreateForm from './modules/CreateForm'
  import { tableMixin } from '@/store/table-mixin'
  
  export default {
    name: 'Config',
    components: {
      CreateForm
    },
    mixins: [tableMixin],
    dicts: ['sys_yes_no'],
    data () {
      return {
        list: [],
        selectedRowKeys: [],
        selectedRows: [],
        // 高级搜索 展开/关闭
        advanced: false,
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        ids: [],
        loading: false,
        refreshing: false,
        total: 0,
        // 日期范围
        dateRange: [],
        queryParam: {
          pageNum: 1,
          pageSize: 10,
          type: 1,
          configName: undefined,
          configKey: 'lookAdNumbers',
          configSystem: undefined
        },
        columns: [
          {
            title: '序号',
            // ellipsis: true,,
            customRender: (text, record, index) => index + 1,
            align: 'center'
          },
          {
            title: '参数名称',
            dataIndex: 'configName',
            // ellipsis: true,
          },
          // {
          //   title: '参数分组',
          //   dataIndex: 'configGroup',
          //   // ellipsis: true,
          // },
          {
            title: '参数键名',
            dataIndex: 'configKey',
            // ellipsis: true,
          },
          // {
          //   title: '参数键值',
          //   dataIndex: 'configValue',
          //   // ellipsis: true,
          // },
          // {
          //   title: '系统内置',
          //   dataIndex: 'configSystem',
          //   scopedSlots: { customRender: 'configSystem' },
          //   align: 'center'
          // },
          // {
          //   title: '备注',
          //   dataIndex: 'remark',
          //   // ellipsis: true,
          // },
          // {
          //   title: '创建时间',
          //   dataIndex: 'createTime',
          //   scopedSlots: { customRender: 'createTime' },
          //   // ellipsis: true,,
          //   align: 'center'
          // },
          {
            title: '操作',
            dataIndex: 'operation',
            width: '15%',
            scopedSlots: { customRender: 'operation' },
            align: 'center'
          }
        ]
      }
    },
    filters: {
    },
    created () {
      this.getList()
    },
    computed: {
    },
    watch: {
    },
    methods: {
      /** 查询参数列表 */
      getList () {
        this.loading = true
        if (this.dateRange !== null && this.dateRange !== '' && this.dateRange.length === 2) {
          this.queryParam.beginTime = this.dateRange[0] +" 00:00:00"
          this.queryParam.endTime = this.dateRange[1]+" 23:59:59"
        }
        pageConfig(this.queryParam).then(response => {
            this.list = response.data.records
            this.total = response.data.total
            this.loading = false
          }
        )
      },
      /** 搜索按钮操作 */
      handleQuery () {
        this.queryParam.pageNum = 1
        this.getList()
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.dateRange = []
        this.queryParam = {
          pageNum: 1,
          pageSize: 10,
          type: 1,
          configName: undefined,
          configKey: 'lookAdNumbers',
          configSystem: undefined
        }
        this.handleQuery()
      },
      onShowSizeChange (current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      changeSize (current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.ids = this.selectedRows.map(item => item.id)
        this.single = selectedRowKeys.length !== 1
        this.multiple = !selectedRowKeys.length
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /** 删除按钮操作 */
      handleDelete (row) {
        var that = this
        const configIds = row.id || this.ids
        this.$confirm({
          title: '确认删除所选中数据?',
          content: '当前选中编号为' + configIds + '的数据',
          onOk () {
            return delConfig(configIds)
              .then(() => {
                that.onSelectChange([], [])
                that.getList()
                that.$message.success(
                  '删除成功',
                  3
                )
            })
          },
          onCancel () {}
        })
      },
      /** 导出按钮操作 */
      handleExport () {
        var that = this
        this.$confirm({
          title: '是否确认导出?',
          content: '此操作将导出当前条件下所有数据而非选中数据',
          onOk () {
            that.download('system/config/export', {
              ...that.queryParam
            }, `config_${new Date().getTime()}.xlsx`)
          },
          onCancel () {}
        })
      },
      /** 刷新缓存按钮操作 */
      handleRefreshCache () {
        this.refreshing = true
        refreshCache().then(() => {
          this.$message.success(
            '刷新成功',
            3
          )
        }).finally(() => {
          this.refreshing = false
        })
      }
    }
  }
  </script>
  